const new_permissions_for_translation = ['transactions-create-receive', 'transactions-create-pay', 'transactions-create-deposit', 'transactions-create-withdrawal_internal', 'transactions-create-exchange_internal']

const translateOldPermission = (permission) => {
  for (let i in new_permissions_for_translation) {
    if (permission.startsWith(new_permissions_for_translation[i])) { return new_permissions_for_translation[i] }
  }
  return permission
}

const onlyUnique = (value, index, self) => { return self.indexOf(value) === index }

const translateOldPermissions = (permissions) => {
  return permissions.map(translateOldPermission).filter(onlyUnique)
}

export default translateOldPermissions



// WEBPACK FOOTER //
// ./src/shared/translateOldPermissions.js